goog.provide("shadow.js.shim.module$$mui$material$CircularProgress$default");
shadow.js.shim.module$$mui$material$CircularProgress$default = shadow.js.require(385, {})["default"];
